import cinemaLogo from "../assets/app/cinema-felice/cinemaFeliceLogo.png"
import cinemaHome from "../assets/app/cinema-felice/demo/Main.jpg"
import cinemaPost from "../assets/app/cinema-felice/demo/Post.jpg"
import moviePost from "../assets/app/cinema-felice/demo/PostPage.jpg"
import movieCollection from "../assets/app/cinema-felice/demo/Collection.jpg"
import movieReview from "../assets/app/cinema-felice/demo/Review.jpg"

import flashLogo from "../assets/app/flashmatch/flashmatchLogo.png";
import flashHome from "../assets/app/flashmatch/demo/Home.png";
import flashRules from "../assets/app/flashmatch/demo/Rules.png";
import flashSingleGame from "../assets/app/flashmatch/demo/Game.png";
import flashLogin from "../assets/app/flashmatch/demo/Login.png";
import flashJoin from "../assets/app/flashmatch/demo/Join.png";
import flashMultiGame from "../assets/app/flashmatch/demo/Multiplayer.jpg";

import fitnessLogo from "../assets/app/fitness/Logo.png";
import fitnessReg from "../assets/app/fitness/demo/Registration.jpg";
import fitnessReg1 from "../assets/app/fitness/demo/Registration Step 1.jpg";
import fitnessReg2 from "../assets/app/fitness/demo/Registration Step 2.jpg";
import fitnessReg3 from "../assets/app/fitness/demo/Registration Step 3.jpg";
import fitnessDashboard from "../assets/app/fitness/demo/User Dashboard.jpg";
import fitnessCaloriesReport from "../assets/app/fitness/demo/Calories Report.jpg";
import fitnessSteps from "../assets/app/fitness/demo/Steps Count.jpg";
import fitnessPhotoTrack from "../assets/app/fitness/demo/Photo Comparer.jpg";
import fitnessPhotoUpload from "../assets/app/fitness/demo/Photo Upload.jpg";
import fitnessPhotoSelect from "../assets/app/fitness/demo/Photo Selection.jpg";
import fitnessPhotoResult from "../assets/app/fitness/demo/Photo Result.jpg";
import workoutTracker from "../assets/app/fitness/demo/Workout Tracker.jpg";
import workoutSched from "../assets/app/fitness/demo/Workout Schedule.jpg";
import workoutAddSched from "../assets/app/fitness/demo/Schedule.jpg";
import workoutActivities from "../assets/app/fitness/demo/Activity Schedule.jpg";
import workoutInstructions from "../assets/app/fitness/demo/Activity Instruction.jpg";
import workoutDone from "../assets/app/fitness/demo/Workout Done.jpg";

import pokegunLogo from "../assets/app/pokegun/logo.png";
import pokeHome from "../assets/app/pokegun/demo/Homepage.png";
import pokeRules from "../assets/app/pokegun/demo/Rules.png";
import pokeMain from "../assets/app/pokegun/demo/Main.png";
import pokeBattleStart from "../assets/app/pokegun/demo/Battle.png";
import pokeBattleEnd from "../assets/app/pokegun/demo/BattleEnd.png";
import pokeFinalBoss from "../assets/app/pokegun/demo/Final Boss.png";
import pokeLoss from "../assets/app/pokegun/demo/Loss.png";

export const APP_INFO = [
  {
    category: "games",
    name: "Pokegun",
    logo: pokegunLogo,
    overview: "A topdown 2D pokemon GBA with a little twist :) For all of us who is nostalgia, as well as for my class project ofc =))",
    redirect_link: "https://github.com/SaadmanX/Pokegun",
    demo_content: [
      {
        image: pokeHome,
        description: "The main entrace point of the game",
      },
      {
        image: pokeRules,
        description: "Rules Explained",
      },
      {
        image: pokeMain,
        description: "The entrance point of the game, there are lots of fields to play around",
      },
      {
        image: pokeBattleStart,
        description: "Battle Screen At the Start of the Game",
      },
      {
        image: pokeBattleEnd,
        description: "As the battle proceeds, logs of their moves are logged for user details",
      },
      {
        image: pokeFinalBoss,
        description: "The final boss map",
      },
      {
        image: pokeLoss,
        description: "Loss screen"
      }
    ],
  },
  {
    category: "games",
    name: "Flashmatch",
    logo: flashLogo,
    custom_border: "green-border",
    overview: "Multiplayer Online Card Pairs (Memory Games), developed using Node.js, Postgres, React and Socket.io",
    redirect_link: "https://513-web-game.vercel.app/",
    demo_content: [
      {
        image: flashHome,
        description: "Home Page of FlashMatch",
      },
      {
        image: flashRules,
        description: "To start of, there is a rule guide for instruction",
      },
      {
        image: flashSingleGame,
        description: "One can start playing solo by Single Player Mode",
      },
      {
        image: flashLogin,
        description: "Alternatively, one can log in to start hosting a game",
      },
      {
        image: flashJoin,
        description: "One can join any game with a given room name here",
      },
      {
        image: flashMultiGame,
        description: "Now the party begin with multiple players and score / ranking",
      },
    ],
  },
  {
    category: "entertainment",
    name: "Cinema Felice",
    logo: cinemaLogo,
    redirect_link: "https://cinemafelice.com/",
    custom_border: "green-border",
    fill_bg: true,
    demo_content: [
      {
        image: cinemaHome,
        description: "Home page of the website",
      },
      {
        image: cinemaPost,
        description: `Post Option on header screen, which will redirect 
          user to another link and page that contains 
          all the available movie analysis posts`,
      },
      {
        image: moviePost,
        description: `On any post clicked, a similar interface will pop up with 
          2 signatures movie scenes chosen from that same titled 
          movie and a written piece of analysis.`,
      },
      {
        image: movieCollection,
        description: `Collection is navigated by clicking on the "Collection" 
          Tab on the header. It displays all the movies being registered in the 
          database of the website (since it is a blog, all of these titles 
          come with a separate mini review)`,
      },
      {
        image: movieReview,
        description: `Mini Review Screen, where it shows the actual "blog", 
          or mini-review and short personal opinion about the movie. Under the 
          review are also some cinematographic, picturesque shots taken from the 
          movie and also some recommended media (i.e analysis posts or review posts 
          from other sources, can be article or videos)`,
      }
    ],
  },
  {
    category: "health",
    name: "FitTech",
    custom_border: "purple-border",
    overview: `A fitness tracker where user can use to schedule and customize their workout routine`,
    logo: fitnessLogo,
    redirect_link: "https://drive.google.com/file/d/1MCuPFljau_DwEiLzSKo4sgiEujzBZxpU/view",
    demo_content: [
      {
        image: fitnessReg,
        description: "First welcome page for new user",
      },
      {
        image: fitnessReg1,
        description: "Second page of registration",
      },
      {
        image: fitnessReg2,
        description: "Third page of registration",
      },
      {
        image: fitnessReg3,
        description: "Last page of registration",
      },
      {
        image: fitnessDashboard,
        description: `Menu of where user can navigate to different features`,
      },
      {
        image: fitnessCaloriesReport,
        description: `Calories Chart`,
      },
      {
        image: fitnessSteps,
        description: `Steps Count Trackers`,
      },
      {
        image: fitnessPhotoTrack,
        description: `Photo tracker is where user can upload their photos to compare and see their progress`,
      },
      {
        image: fitnessPhotoUpload,
        description: `Where users can upload their photos`,
      },
      {
        image: fitnessPhotoSelect,
        description: `Where users can choose 2 months to get the corresponding photos and results compared`,
      },
      {
        image: fitnessPhotoResult,
        description: `Results from photos chosen by Photo Selection`,
      },
      {
        image: workoutTracker,
        description: `User can either view their workout schedule here, or start their upcoming workout (from the same day)`,
      },
      {
        image: workoutSched,
        description: `Workout Schedule, where user can choose each day and view their according workout schedule`,
      },
      {
        image: workoutAddSched,
        description: `Users can customize and add their own activity into the schedule`,
      },
      {
        image: workoutActivities,
        description: `Description of each activity set/routine`,
      },
      {
        image: workoutInstructions,
        description: `Specific instruction for every exercise`,
      },
      {
        image: workoutDone,
        description: `Workout done message`
      }
    ],
  },
  {
    category: "shopping",
    name: "La Musica",
    logo: "",
    redirect_link: "",
    demo_content: [
      {
        image: "",
        description: "",
      },
    ],
  },
];
